module.exports = __webpack_public_path__ + "static/media/blank_booking_icon.08d6e8ae.svg";